import axios from 'axios'

export const REFERENTIAL_GRID_S3_CACHE_CONTROL = 'max-age=0, must-revalidate'

export async function uploadReferentialGridToS3(signedUrl: string, file: Blob): Promise<void> {
  await axios.put(signedUrl, file, {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': REFERENTIAL_GRID_S3_CACHE_CONTROL,
    },
  })
}
